<div *ngIf="ShowContent">
  <div class="container-fluid" *ngIf="!workflowCode">
    <br />
    <alert></alert>
    <br />
    <div class="d-flex justify-content-between">
      <h1 class="text-primary" data-testid="pageTitle">{{'WorkflowSearch.Title' | translate}}</h1>
      <!--<button type="button" aria-label="ListaPedidos" class="btn btn-primary" (click)="navigateToInstanceBrowser()"
              visualActionUnauthorized action="{{VisualActions.hide}}" permission="WorkflowCreationPage.AccessPage">-->
      <button type="button" aria-label="ListaPedidos" class="btn btn-primary" (click)="navigateToInstanceBrowser()">
        <span class="icon-burger-menu"></span>
        <span>{{'WorkflowSearch.InstanceBrowser' | translate}}</span>
      </button>
</div>
  <form>
    <div class="form-row align-items-center">
      <div class="input-group col-12 mt-4 mb-4">
        <div class="input-group-prepend">
          <div class="input-group-text icon-search"></div>
        </div>
        <input type="text" class="form-control search-workflow" placeholder="{{'WorkflowSearch.SearchPlaceholder' | translate}}"
               name="wfSearch" (keyup)="filterWorkList($event)" [(ngModel)]="filter">
      </div>
      <!--<div class="input-group col-12 mt-4 mb-4">
        <span class="text-primary">
          {{'Generic.PdfHelper' | translate}}
          <a href="" (click)="getFAQFormulario()" class="card-link text-primary">{{'Generic.LinkGuide' | translate}}</a>
          <a href="" (click)="getGuiaFormulario()" class="card-link text-primary">{{'Generic.LinkGuideForm' | translate}}</a>
        </span>
      </div>-->
    </div>
  </form>
  <div class="row">
    <div class="col-sm-12 col-md-4" *ngFor="let card of cards;trackBy: trackByFn">
      <div class="card">
        <div class="card-body mb-4">
          <div [ngSwitch]="card.workflowFileType">
            <ng-content *ngSwitchCase="'PGP'">
              <span class="card-subtitle">{{card.workflowCodeCGA}}</span>
              <a *ngIf="card.workflowCode == 'PEDI001' || card.workflowCode == 'PEDI0020'"
                 aria-label="Criar um pedido" referrerpolicy="origin" href=""
                 [routerLink]="['/workflow-create', card.workflowCode]">
                <h1 class="card-title mb-1">{{card.title}}</h1>
              </a>
              <a *ngIf="card.workflowCode == 'PEDI002' "
                 aria-label="Criar um pedido" referrerpolicy="origin" href=""
                 [routerLink]="['/workflow-create-pm', card.workflowCode,0,'DeceasedIdentification']">
                <h1 class="card-title mb-1">{{card.title}}</h1>
              </a>
              <a *ngIf="card.workflowCode == 'PEDI008' || card.workflowCode == 'PEDI005'" aria-label="Criar um pedido" referrerpolicy="origin"
                 class="underline" (click)="canCreatePrestage(card.workflowCode)">
                <h1 class="card-title mb-1">{{card.title}}</h1>
              </a>

                <p class="text-secondary ft-sz-12 block-ellipsis" *ngIf="card.workflowSupportText">{{card.workflowSupportText}}</p>
                <span class="ft-sz-12" *ngIf="card.workflowFileType == 'PDF'">{{card.workflowFileType + ' ' + card.workflowFileSyze + ' | ' + card.workflowFilePages + ' | ' + card.workflowFileVersion + ' ' + card.workflowFileVersionDate}}</span>
                <p class="ft-sz-12" *ngIf="card.workflowPrintLink">
                  <br />
                  <span class="icon-download text-primary"></span>
                  &nbsp;
                  <a [routerLink]="" aria-label="Download Pdf" (click)="getPdf(card.workflowCode)" class="card-link text-primary" referrerpolicy="origin">{{'WorkflowSearch.ManualDownload' | translate}}</a>
                </p>
              </ng-content>
              <ng-content *ngSwitchCase="'WEB'">
                <span class="card-subtitle">{{card.workflowCodeCGA}}</span>
                <a href="{{oldForms11 + card.workflowExternalLink}}" target="_blank" aria-label="Criar um pedido" referrerpolicy="origin">
                  <h1 class="card-title mb-1">{{card.title}}</h1>
                </a>

                <p class="text-secondary ft-sz-12 block-ellipsis" *ngIf="card.workflowSupportText">{{card.workflowSupportText}}</p>
                <span class="ft-sz-12" *ngIf="card.workflowFileType == 'PDF'">{{card.workflowFileType + ' ' + card.workflowFileSyze + ' | ' + card.workflowFilePages + ' | ' + card.workflowFileVersion + ' ' + card.workflowFileVersionDate}}</span>
                <p class="ft-sz-12" *ngIf="card.workflowPrintLink">
                  <br />
                  <span class="icon-download text-primary"></span>
                  &nbsp;
                  <a [routerLink]="" aria-label="Download Pdf" (click)="getPdf(card.workflowCode)" class="card-link text-primary" referrerpolicy="origin">{{'WorkflowSearch.ManualDownload' | translate}}</a>
                </p>
              </ng-content>
              <ng-content *ngSwitchCase="'PDF'">
                <span class="card-subtitle">{{card.workflowCodeCGA}}</span>
                <div *ngIf="card.workflowExternalLink == ''">

                  <a target="_blank" aria-label="Criar um pedido" referrerpolicy="origin">
                    <h1 class="card-title mb-1 fake-link">{{card.title}}</h1>
                  </a>
                </div>
                <div *ngIf="card.workflowExternalLink?.length>0 ">

                  <a href="{{oldForms + card.workflowExternalLink}}" target="_blank" aria-label="Criar um pedido" referrerpolicy="origin">
                    <h1 class="card-title mb-1 fake-link">{{card.title}}</h1>
                  </a>
                </div>

                <p class="text-secondary ft-sz-12 block-ellipsis" *ngIf="card.workflowSupportText">{{card.workflowSupportText}}</p>
                <span class="ft-sz-12" *ngIf="card.workflowFileType == 'PDF'">{{card.workflowFileType + ' ' + card.workflowFileSyze + ' | ' + card.workflowFilePages + ' | ' + card.workflowFileVersion + ' ' + card.workflowFileVersionDate}}</span>
                <p class="ft-sz-12" *ngIf="card.workflowPrintLink">
                  <br />
                  <span class="icon-download text-primary"></span>
                  &nbsp;
                  <a [routerLink]="" aria-label="Download Pdf" (click)="getPdf(card.workflowCode)" class="card-link text-primary" referrerpolicy="origin">{{'WorkflowSearch.ManualDownload' | translate}}</a>
                </p>
              </ng-content>






            </div>

            <div class="d-flex justify-content-between align-items-center mt-3">
              <a [style.visibility]="card.workFlowHelpLink ? 'visible' : 'hidden'" [routerLink]="" aria-label="Link com Instruções" (click)="card.workFlowHelpLink && getInstructions(card.workflowCode)" class="card-link" referrerpolicy="origin">{{'WorkflowSearch.Instructions' | translate}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- FORM FAKE -->
<form id="formGetFile" #cgaGetFileForm="ngForm" name="formGetFile" method="POST" target="_blank"  referrerpolicy="origin">
  <input #cgaGetFileFormInput type="hidden" name="h_queryParams" id="h_queryParams" value="">
  <input type="hidden" name="h_transfDir" id="h_transfDir" value="Download">
  <input type="hidden" name="h_operId" id="h_operId" value="PubFich">
</form>

<ng-template #subscriberIntervention>
  <div class="modal-header">
    <h5 class="modal-title text-danger d-flex align-items-center">
      <span class="icon-error mr-2 ft-sz-24"></span>
      {{'WorkflowCreate.NoRegistrationTitle' | translate}}
    </h5>
    <button type="button" class="close pull-right" aria-label="Fechar" (click)="modalRef.hide()">
      <span aria-hidden="true" class="icon-close"></span>
    </button>
  </div>
  <div class="modal-body">
    {{'WorkflowCreate.NoRegistrationText' | translate}}
    <br><br>
    {{'WorkflowCreate.NoRegistrationText2' | translate}}
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" aria-label="Rejeitar" (click)="decline()"><span class="icon-check"></span><span>Ok</span></button>
  </div>
</ng-template>
